import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import StudentPage from './pages/StudentPage';
import TeacherPage from './pages/TeacherPage';
import AdminPage from './pages/AdminPage';
import DemoPage from './pages/DemoPage';

function ProtectedRoute({ element, requiredRole }) {
  const token = localStorage.getItem('token');
  const role = localStorage.getItem('role');
  const isDemo = localStorage.getItem('isDemo') === 'true';

  // デモユーザーが教師・児童以外にアクセスしようとした場合は/demoに戻す
  if (isDemo && requiredRole === 'admin') {
    return <Navigate to="/demo" />;
  }

  if (!token || (requiredRole && role !== requiredRole)) {
    localStorage.clear();
    return <Navigate to="/login" />;
  }

  return element;
}

function LoginRoute() {
  const token = localStorage.getItem('token');
  const isDemo = localStorage.getItem('isDemo') === 'true';
  if (token && isDemo) return <Navigate to="/demo" />;
  return <LoginPage />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<LoginRoute />} />
        <Route path="/student" element={<ProtectedRoute element={<StudentPage />} requiredRole="student" />} />
        <Route path="/teacher" element={<ProtectedRoute element={<TeacherPage />} requiredRole="teacher" />} />
        <Route path="/admin" element={<ProtectedRoute element={<AdminPage />} requiredRole="admin" />} />
        <Route path="/demo" element={<DemoPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
